export default __webpack_public_path__ + "static/media/legal-1.0384c0fa.jpg";